import { createAction } from "@ngrx/store";

const prefix = "[Technical Roles Toggle]";

export const toggleShowTechnicalRoles = createAction(
  `${prefix} Toggle Show Technical Roles`,
);
